/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator>): InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator(), model);
        InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator>): InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorLambdaRuntimeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the Lambda runtime
     */
    starts_with: string;

}
